import React from 'react';

const BasePage = props => (
    <div className="">
        {props.children}
    </div>
)

export default BasePage;